import * as React from 'react';
import { CONTAINER_WIDTH } from '../../../../global/constants';

type Props = {
  children: React.ReactNodeArray | React.ReactNode;
};

export function PublicFacingFormWrapper(props: Props) {
  return (
    <div style={{ maxWidth: `${CONTAINER_WIDTH}px`, margin: '0 auto' }}>
      {props.children}
    </div>
  );
}
